import { render, staticRenderFns } from "./DeviceRecord.vue?vue&type=template&id=0b5121ae&scoped=true"
import script from "./DeviceRecord.vue?vue&type=script&lang=js"
export * from "./DeviceRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5121ae",
  null
  
)

export default component.exports